import { render, staticRenderFns } from "./DoughnutWrapper.vue?vue&type=template&id=a117919a&scoped=true"
import script from "./DoughnutWrapper.vue?vue&type=script&lang=js"
export * from "./DoughnutWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a117919a",
  null
  
)

export default component.exports